module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "position-relative"
  }, [_c('div', {
    staticClass: "navigation"
  }, [_c('div', {
    staticClass: "position-back"
  }, [_c('div', {
    staticClass: "button is-small",
    on: {
      "click": function($event) {
        return _vm.$emit('prev')
      }
    }
  }, [_vm._m(0), _c('span', [_vm._v("Previous step")])])])]), _vm._m(1), _vm._m(2), _c('div', {
    staticClass: "features address-info"
  }, [_c('div', {
    staticClass: "box-container"
  }, [_c('div', {
    staticClass: "element-box-container is-best",
    on: {
      "click": function($event) {
        return _vm.select(_vm.algorithm.globalServer)
      }
    }
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v("Recommended")]), _c('span', {
    staticClass: "name server"
  }, [_vm._v(_vm._s(_vm.algorithm.globalServer.description))]), _c('br'), _c('span', {
    staticClass: "explanation"
  }, [_vm._v("By using the global server we will auto select the closest server to your location")]), _c('br'), _c('span', {
    staticClass: "url"
  }, [_vm._v(_vm._s(_vm.algorithm.globalServer.url))])])]), _c('div', {
    staticClass: "columns is-multiline features jc-center"
  }, _vm._l((_vm.algorithm.alternativeServers), function(o) {
    return _c('div', {
      staticClass: "column is-half"
    }, [_c('div', {
      staticClass: "box-container"
    }, [_c('div', {
      staticClass: "element-box-container",
      on: {
        "click": function($event) {
          return _vm.select(o)
        }
      }
    }, [_c('div', {
      staticClass: "region-image"
    }, [_c('img', {
      attrs: {
        "src": '/img/region/' + o.country + '.png'
      }
    })]), _c('span', {
      staticClass: "name server"
    }, [_vm._v(_vm._s(o.description))]), _c('br'), _c('span', {
      staticClass: "url"
    }, [_vm._v(_vm._s(o.url))])])])])
  }), 0)]), _c('div', {
    staticClass: "feature-helvetica step-explanation"
  }, [_vm._m(3), _c('div', {
    staticClass: "articles"
  }, [_c('router-link', {
    staticClass: "article-mini",
    attrs: {
      "to": "/support/article/how-to-run-a-ping-command",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "article-inner"
  }, [_c('div', {
    staticClass: "article-title"
  }, [_c('span', [_vm._v(" How to run a ping command")])]), _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-external-link"
  })])])])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step-title"
  }, [_c('span', [_vm._v("Select your region")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-5 has-text-left text-white-on-dark"
  }, [_c('span', [_vm._v("Be sure to select the closest server to your geographic location, or simply use our global server:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-10"
  }, [_c('span', [_vm._v("You may try running a ping command directly from your console to check for the best (lowest) latency server:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-768043ac","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/get_started/c_step_region.vue
// module id = 384
// module chunks = 1